module.exports = __webpack_public_path__ + "media/images/athletes/1804-840eb26d28614a5797a7fa48da76cf24.png";